<ng-container *ngIf="insight$ | async as insight">
    <div datasetTableInsightEdit [insight]="insight" [projectKey]="projectKey$ | async" [datasetOptions]="datasetOptions$ | async" [appConfig]="appConfig$ | async"></div>
</ng-container>
